import React from "react";
import ReactDOM from "react-dom/client";
import { AppInsightsContext, AppInsightsErrorBoundary, ReactPlugin } from "@microsoft/applicationinsights-react-js";

import App from "./App";
import "../i18n";
import "./index.css";
import { ErrorPage } from "./components/ErrorPage";
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { Provider as ChakraProvider } from "./providers/ChakraProvider";

const AppInsightsReactPlugin = new ReactPlugin();
const SESSION_SAMPLE_RATE = 100;
datadogRum.init({
    applicationId: import.meta.env.VITE_DD_CLIENTID,
    clientToken: import.meta.env.VITE_DD_CLIENTTOKEN,
    site: "datadoghq.eu",
    service: "claims-invoicing-frontend",
    env: import.meta.env.VITE_DD_ENVIRONMENT,
    version: import.meta.env.VITE_DEPLOYED_VERSION,
    sessionSampleRate: SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input"
});

datadogLogs.init({
    clientToken: "pub137d4cc970353a3718653dd1f3af5c5d",
    site: "datadoghq.eu",
    forwardErrorsToLogs: true,
    sessionSampleRate: SESSION_SAMPLE_RATE
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <AppInsightsContext.Provider value={AppInsightsReactPlugin}>
            <AppInsightsErrorBoundary onError={ErrorPage} appInsights={AppInsightsReactPlugin}>
                <ChakraProvider>
                    <App />
                </ChakraProvider>
            </AppInsightsErrorBoundary>
        </AppInsightsContext.Provider>
    </React.StrictMode>
);
